const theme = {
  colors: {
    primary: '#59B4D6',
    background: '#FFFFFF',
    shape: '#d3ebf4',
    title: '#222222',
    text: '#1C2250',
    components: {
      blockquote: {
        background: '#59B4D6',
        text: '#1C2250',
      },
    },
  },
};

export default theme;